import importerStore from '@shared/importer/importer-store';
import { InscriptionService } from '@modules/inscription/inscription-service';
import inscriptionImporterFields from '@modules/inscription/inscription-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
    InscriptionService.import,
    inscriptionImporterFields,
    i18n('entities.inscription.importer.fileName'),
    i18n('entities.inscription.importer.hint'),
);